import { render, staticRenderFns } from "./AtoImg.vue?vue&type=template&id=08ae4ba8&lang=pug"
import script from "./AtoImg.vue?vue&type=script&lang=js"
export * from "./AtoImg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports